<script setup>
  import { ref } from 'vue'
  import { TitleH1 } from '@/components/Titles'

  defineProps({
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    titleClass: {
      type: String,
      required: false,
    },
    closeButtonText: {
      type: String,
      default: 'Cancelar',
    },
    closeButtonHidden: {
      type: Boolean,
      default: false,
    },
    saveButtonText: {
      type: String,
      default: 'Salvar',
    },
    saveButtonDisabled: {
      type: Boolean,
      default: false,
    },
    cancelButtonDisabled: {
      type: Boolean,
      default: false,
    },
    onSave: {
      type: Function,
      default: () => {},
    },
    onCancel: {
      type: [Function, null],
    },
  })

  const closeButton = ref(null)
  const openButton = ref(null)
  const statusModal = ref(false)

  function _hide() {
    if (statusModal.value) {
      closeButton.value.click()
      statusModal.value = false
    }
  }
  function _show() {
    if (!statusModal.value) {
      openButton.value.click()
      statusModal.value = true
    }
  }
  defineExpose({
    hide: _hide,
    open: _show,
    statusModal: statusModal.value,
  })
</script>

<template>
  <button
    ref="openButton"
    type="button"
    data-bs-toggle="modal"
    :data-bs-target="`#${id}`"
    style="display: none"
  ></button>
  <div
    class="modal fade"
    :id="id"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header row">
          <div class="col-12">
            <TitleH1>
              {{ title }}
            </TitleH1>
          </div>
          <button
            v-show="!closeButtonHidden"
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="closeButton"
            @click="() => (statusModal = false)"
          ></button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer gap-2 justify-content-center">
          <button
            type="button"
            class="btn btn-secondary btn-modal"
            @click="() => (onCancel ? onCancel() : _hide())"
            :disabled="cancelButtonDisabled"
          >
            {{ closeButtonText }}
          </button>
          <button
            type="button"
            class="btn btn-primary btn-modal"
            @click="onSave"
            :disabled="saveButtonDisabled"
          >
            {{ saveButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
